class SpacebarEvent
{
    constructor(tagify) {
        this.tagify = tagify;
        tagify.on('keydown', function(e) {
            let tgInput =  $('.tagify__input');
            if(e.detail.event.key === ' ' || e.detail.event.code === 'Space') {
                if($(tgInput).text() === '') {
                    setTimeout(() => {
                        $(tgInput).text('');
                    },  0);
                    return;
                }
                e.detail.tagify.addTags([{value:  $(tgInput).text()}]);
                $(tgInput).text('');
                setTimeout(() => {
                    $(tgInput).text('');
                }, 0);
            }
        });
    }
}

window.SpacebarEvent = SpacebarEvent;